export const selectEvents = 'selectEvents';
